import 'css-chunksrc/client/pages/personalSpacePage/synthesis/tasks/task/taskStatus/status/styles.scss';export default {
  "main": "_main_1m7zg_1",
  "button": "_button_1m7zg_5",
  "reduced": "_reduced_1m7zg_19",
  "paragraph": "_paragraph_1m7zg_26",
  "square": "_square_1m7zg_33",
  "icon": "_icon_1m7zg_47",
  "menu": "_menu_1m7zg_55",
  "form": "_form_1m7zg_72",
  "visibleForm": "_visibleForm_1m7zg_76",
  "formSwitch": "_formSwitch_1m7zg_80",
  "hiddenFormSwitch": "_hiddenFormSwitch_1m7zg_86",
  "opened": "_opened_1m7zg_90",
  "readOnly": "_readOnly_1m7zg_95"
};